import { useMemo } from 'react'
import { useIsManager, useProfile, useTranslation } from '@front/model'
import { type PageRoute } from '../navigation'
import { useSettingsRoutes } from '../appShell/useSettingsRoutes'
import { useRoutes } from '../appShell/useRoutes'
import { useIntegrationRoutes } from '../appShell/useIntegrationRoutes'
import { collectSpotlightDestinations } from './spotlightDestinations'

export function useSearchDestinations(): PageRoute[] {
  const { t } = useTranslation()
  const { routes, isPending } = useRoutes()
  const settingsRoutes = useSettingsRoutes()
  const integrationRoutes = useIntegrationRoutes()
  const { isAdmin, isTantalim, hasPermission } = useProfile()
  const { isManager } = useIsManager()

  return useMemo(
    () =>
      collectSpotlightDestinations({
        sidebarRoutes: routes,
        // Static secondary columns only. A role, chat, or program sidebar is entity state, not an app destination.
        nestedSources: [
          { parentPath: '/settings', section: t('Settings'), routes: settingsRoutes },
          { parentPath: '/integration', section: t('Integrations'), routes: integrationRoutes },
        ],
        isPending,
        visibility: { isAdmin, isManager, isTantalim, hasPermission },
      }),
    [routes, settingsRoutes, integrationRoutes, isPending, isAdmin, isManager, isTantalim, hasPermission, t]
  )
}
